import React from 'react';
import { Translate } from 'react-redux-i18n';
import Requirement from './Requirement';

type Props = {
  value: string,
};

function PasswordHelper({ value }: Props): JSX.Element {
  return (
    <div className="password-helper">

      <Requirement value={value} type="lowercase">
        <Translate value="HELPER.MINUSCULE" />
      </Requirement>
      <Requirement value={value} type="uppercase">
        <Translate value="HELPER.MAJUSCULE" />
      </Requirement>
      <Requirement value={value} type="numeric">
        <Translate value="HELPER.NUMBER" />
      </Requirement>
      <Requirement value={value} type="special">
        <Translate value="HELPER.SPECIAL" />
      </Requirement>
      <Requirement value={value} type="length">
        <Translate value="HELPER.LENGTH" />
      </Requirement>

    </div>
  );
}

export default PasswordHelper;
